import { render, staticRenderFns } from "./NameCompo.vue?vue&type=template&id=b38d1b62&"
import script from "./NameCompo.vue?vue&type=script&lang=js&"
export * from "./NameCompo.vue?vue&type=script&lang=js&"
import style0 from "./NameCompo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports